module.exports = __webpack_public_path__ + "static/media/6.2f632e1f.jpg";